import { getGlobalConfig } from '../global/ConfigProvider';

export function getFeatureFlag(flag: string) {
  return Boolean(window.wbConfig?.[flag]);
}

export function useFeatureFlag(flag: string) {
  const { enabledFeatures } = getGlobalConfig();
  return enabledFeatures.includes(flag);
}
